import cx from 'clsx';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const ArchiveTableSkeleton = () => {
  return [...Array(10)].map(() => {
    const rowKey = uuidv4();
    return (
      <tr key={rowKey} className={cx(style.archivedAiBodyRow, style.skeletonRow)}>
        <td>
          <SkeletonBlock className={style.skeletonText} />
        </td>
        <td>
          <SkeletonBlock className={style.skeletonText} />
        </td>
        <td className={style.hideColumn}>
          <SkeletonBlock className={style.skeletonText} />
        </td>
        <td>
          <SkeletonBlock className={style.skeletonText} />
        </td>
        <td>
          <SkeletonBlock className={style.skeletonText} />
        </td>
        <td className={style.hideColumn}>
          <SkeletonBlock className={style.skeletonText} />
        </td>
        <td>
          <SkeletonBlock className={style.skeletonText} />
        </td>
        <td>
          <SkeletonBlock className={style.skeletonCircle} />
        </td>
      </tr>
    );
  });
};

export default ArchiveTableSkeleton;
